import type { ComponentProps } from 'react';
import { OwcThemeProvider } from '@one/react';

export type PocThemeProviderProps = ComponentProps<typeof OwcThemeProvider>;

export const PocThemeProvider: React.FC<PocThemeProviderProps> = (props) => <OwcThemeProvider {...props} />;
